export const AnnouncementBarView = Backbone.View.extend({
  el: '#announcementBar',
  events: {
    'click .js-announcementMessage': 'redirectAndTrack',
    'click .js-announcementBarClose': 'updateAnnouncementCookie'
  },

  delegateEvents() {
    Backbone.View.prototype.delegateEvents.apply(this, arguments);

    // Prevent the click event on .js-announcementMessage from impacting the child anchor tag
    $('.js-announcementMessage a').on('click', function(event) {
      event.stopPropagation();

      const trackingData = $(event.currentTarget).data('tracking') || {};
      const textContent = $(event.currentTarget).closest('.js-announcementMessage').data('textcontent');

      Tracking.dataLayerPush({
        clickCode: trackingData.clickCode || 'clickProductTabs',
        gaCategory: trackingData.gaCategory || PAGE_SCRIPTS.page_template,
        gaAction: trackingData.gaAction || 'click on top banner',
        gaLabel: trackingData.gaLabel || textContent,
        event: 'clickEvent'
      });
    });
  },

  redirectAndTrack(e) {
    const $currentTarget = $(e.currentTarget);
    const linkSrc = $currentTarget.data('linksrc');
    const linkTarget = $currentTarget.data('linktarget');
    const textContent = $currentTarget.data('textcontent');
    let newWindow = window.open('', linkTarget); // Open a blank window immediately (used for none blocking popup)

    if (textContent && linkSrc) {
      Tracking.dataLayerPush({
        clickCode: 'clickProductTabs',
        gaCategory: PAGE_SCRIPTS.page_template,
        gaAction: 'click on top banner',
        gaLabel: textContent,
        event: 'clickEvent'
      });

      if (newWindow) newWindow.location = linkSrc; // Redirect it after the tracking (used for none blocking popup)
    }
  },

  updateAnnouncementCookie() {
    cookieManagement.createCookie('announcementCookie', JSON.stringify(true), 30);
    $('#announcementBar').slideUp(400);
  }
});
